import axios from 'index/axios'

/**
 * 创建申诉批次
 */
export const createAppealBatch = data => axios.post('/Appeal/batch/create', data, { loading: 'createBatch' })

/**
 * 上传申诉凭证
 */
export const uploadAppealEvidence = file => {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post('/Appeal/upload/image', formData, {
        loading: 'upload',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(({ data = {} }) => data.data || {})
}

/**
 * 获取批次准备信息
 */
export const getAppealBatchPrepare = answerKeys => axios.post('/Appeal/batch/prepare', answerKeys, { loading: 'prepare' }).then(({ data = {} }) => data.data || [])

/**
 * 阶段证据：按波次获取非考试阶段的题目清单
 */
export const getStageQuestionList = (waveId, appealFormKey) =>
  axios.post('/Appeal/stage/question-list', { waveId, appealFormKey }).then(({ data = {} }) => data.data || [])

/**
 * 阶段证据：按门店+题目批量拉取文件
 */
export const pullStageEvidence = (waveId, dealerCodes, itemKeys) =>
  axios.post('/Appeal/stage/evidence-pull', { waveId, dealerCodes, itemKeys }).then(({ data = {} }) => data.data || [])
